import { Ok, Result } from 'ts-res';
import { KameleoonData } from 'src/kameleoonData/types';
import { KameleoonError } from 'src/kameleoonError';
import { Parser } from 'src/utilities';
import { EvaluationDataType, MatchType } from 'src/targeting/types';
import { ConditionDataType, ICondition } from './types';
import { KameleoonLogger } from 'src/logging';
import { PageUtils } from './utilities';

export class PageUrl implements ICondition {
  private matchType?: MatchType | null;
  private conditionValue?: string | null;

  constructor({ matchType, url }: ConditionDataType) {
    this.matchType = matchType;
    this.conditionValue = url;
  }

  public evaluate({
    targetingData,
  }: EvaluationDataType): Result<boolean, KameleoonError> {
    const pageViewData = targetingData?.[KameleoonData.PageView];

    if (!pageViewData) {
      return Ok(false);
    }

    const latestPageView = PageUtils.getLatest(pageViewData);

    return Ok(this.checkCondition(latestPageView.urlAddress));
  }

  private checkCondition(url: string): boolean {
    if (!this.matchType || !this.conditionValue) {
      return false;
    }

    switch (this.matchType) {
      case MatchType.CONTAINS:
        return url.includes(this.conditionValue);
      case MatchType.EXACT:
        return url === this.conditionValue;
      case MatchType.REGULAR_EXPRESSION:
        return Parser.parseRegExp(this.conditionValue).test(url);
      default:
        KameleoonLogger.error`Unexpected comparing operation for PageUrl condition: ${this.matchType}`;
        return false;
    }
  }
}
